import React from "react";
import { Chip } from "@mui/material";
import { PokemonContext } from "../context/pokemonContext";

const Characteristics = () => {

    const { pokemon } =React.useContext(PokemonContext);

    return (
        <div className="characteristics">
            <div>
                <div className="row">
                    <div className="col-5 text-end">Color : </div>

                    <div className="col-7">
                        <Chip 
                            label={pokemon.color} 
                            color="primary" 
                            style={{
                                backgroundColor:pokemon.color,
                                color: pokemon.color==='white' ? 'black' : 'white',
                            }} 
                        />
                    </div>
                </div>
                
                <div className="row">
                    <div className="col-5 text-end">Gender Ratio : </div>

                    <div className="col-7">
                        <div className="progress">
                            <div className="progress-bar" style={{width:pokemon.female+'%', backgroundColor:'#c2185b'}}>
                                <small>{pokemon.female}</small>
                            </div>

                            <div className="progress-bar" style={{width:pokemon.male+'%', backgroundColor:'#1976d2'}}>
                                <small>{pokemon.male}</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-5 text-end">Abilities : </div>

                    <div className="col-7">
                        {
                            pokemon.abilities.map((ability, index) => {
                                return <span key={index}>{ability.ability.name} </span>
                            })
                        }
                    </div>
                </div>

                <div className="row">
                    <div className="col-5 text-end">Egg Groups : </div>

                    <div className="col-7">
                        {
                            pokemon.eggGroups.map((egg, index) => {
                                return <span key={index}>{egg.name} </span>
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Characteristics;